import { Routes } from '@angular/router';
import { LoginLayoutComponent } from './shared/layout/login-layout/login-layout.component';
import { mfaGuard } from './core/guards/mfa.guard';

export const routes: Routes = [
  {
    path: '',
    component: LoginLayoutComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/login/login.component').then((m) => m.LoginComponent),
      },
      {
        path: 'mfa',
        canActivate: [mfaGuard],
        loadComponent: () =>
          import('./features/mfa-verification/mfa-verification.component').then(
            (m) => m.MfaVerificationComponent,
          ),
      },
      {
        path: 'senha/recuperacao',
        loadComponent: () =>
          import('./features/password-reset/password-reset.component').then(
            (m) => m.PasswordResetComponent,
          ),
      },
      {
        path: 'senha/definicao',
        loadComponent: () =>
          import('./features/password-definition/password-definition.component').then(
            (m) => m.PasswordDefinitionComponent,
          ),
      },
      {
        path: 'logout',
        loadComponent: () =>
          import('./features/logout/logout.component').then((m) => m.LogoutComponent),
      },
      { path: '**', redirectTo: '' },
    ],
  },
];
